import React, { Component, setState } from 'react';
import PropTypes, { func } from 'prop-types';

import './Products.css';
import Product from './Product';

const products = [
  {
    emoji: '🍦',
    name: 'ice cream',
    price: 5,
  },
  {
    emoji: '🍩',
    name: 'donuts',
    price: 2.5,
  },
  {
    emoji: '🍉',
    name: 'watermelon',
    price: 7,
  },
  {
    emoji: '🍌',
    name: 'banana',
    price: 4,
  },
  {
    emoji: '🍔',
    name: 'hamburger',
    price: 9,
  },
  {
    emoji: '🍕',
    name: 'pizza',
    price: 14,
  },
  {
    emoji: '🍞',
    name: 'bread',
    price: 3,
  },
  {
    emoji: '🌭',
    name: 'hotdog',
    price: 11,
  },
];

class Products extends Component {
  render() {
    const { updateCart } = this.props;

    return (
      <div className="products-list">
        {products.map((product, index) => (
          <Product
            emoji={product.emoji}
            name={product.name}
            price={product.price}
            key={`product-${index}`}
            updateCart={updateCart}
          />
        ))}
      </div>
    );
  }
}

Products.propTypes = {
  updateCart: PropTypes.func,
};

export default Products;
